let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8M6vo"), load("1Qnbq"), load("aDV08")]).then(() => parcelRequire('ef32u'));